import React from 'react';

// import contact data
import { contact } from '../data';

import emailjs from '@emailjs/browser'
import { useRef } from 'react';

import { useAlert } from "react-alert";

const Contact = (type, mssg ) => {
  const alert = useAlert();
  const form = useRef()
  const sendEmail = (e) => {
    e.preventDefault();
  
    emailjs.sendForm('service_rc0oamo', 'template_kej2rdb', form.current, '-1d27Xl86FDkBVuUm')
      .then((result) => {
          console.log(result.text);
          alert.success("Message Sent!");
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset()
  };

  return (
    <section className='section bg-primary' id='contact'>
      <div className='container mx-auto'>
        <div className='flex flex-col items-center text-center'>
          <h2 className='section-title before:content-contact relative before:absolute before:opacity-40 before:-top-7 before:-left-40 before:hidden before:lg:block'>
            Contact me
          </h2>
          <p className='subtitle'>
            If your intuition has brought you this far, I think you should trust it more by reaching out to us. 
          </p>
        </div>
        <div
          className='flex flex-col lg:gap-x-8 lg:flex-row'
        >
          <div
            className='flex flex-1 flex-col items-start space-y-8 mb-12 lg:mb-0 lg:pt-2'
          >
            {contact.map((item, index) => {
              const { icon, title, subtitle, description } = item;
              return (
                <div className='flex flex-col lg:flex-row gap-x-4' key={index}>
                  <div className='text-accent rounded-sm w-14 h-14 flex items-start justify-center mt-2 mb-4 lg:mb-0 text-2xl'>
                    {icon}
                  </div>
                  <div>
                    <h4 className='font-body text-xl mb-1'>{title}</h4>
                    <p className='mb-1 text-paragraph'>{subtitle}</p>
                    <p className='text-accent font-normal '>{description}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <form ref={form} 
            className='space-y-8 w-full max-w-[780px]' onSubmit={sendEmail}
          >
            <div className='flex gap-8'>
              <input className='input' type='text' placeholder='Your name' name='user_name' required/>
              <input className='input' type='email' placeholder='Your email' name='user_email' required/>
            </div>
            <input className='input' type='text' placeholder='Subject' name='subject' required/>
            <textarea
              className='textarea'
              placeholder='Your message' name='message' required
            ></textarea>
            <button className='btn btn-lg bg-accent hover:bg-secondary-hover' type='submit'  >
              Send message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
